import { parsePhoneNumber } from "libphonenumber-js"

export const formatPhoneNumber = (msisdn: string|null) => {
    if (!msisdn) {
      return null
    }
  
    const phoneNumber = parsePhoneNumber(msisdn, 'BE')
    if (phoneNumber) {
      return phoneNumber.formatNational()
    }
  
    return msisdn
  }